/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'
import { ShoppingCartIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Theme } from '@nexigendigital/nxui'
import { Weight } from 'models/enums'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CartEmpty() {
    return (
        <StyledCartEmpty>
            <ShoppingCartIcon/>
            <p>Your Cart is Empty</p>
        </StyledCartEmpty>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledCartEmpty = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > svg {
        fill: ${props => props.theme['icon--200']};
        width: 48px;
        height: 48px;
    }

    > p {
        ${Theme.Functions.setFont('Inter', Weight.Medium)};
        color: ${props => props.theme['text--100']};
    }
`
